export const company = {
    brand: 'ConcreTrack',
    legalName: 'BBA GmbH',
    street: 'Silberberger Chaussee 14',
    postalCode: '15526',
    city: 'Bad Saarow',
    country: 'Deutschland',
    managingDirector: 'Dr.-Ing. Jörn Budde',
    phone: '+49 174 4935860',
    phoneHref: 'tel:+491744935860',
    email: 'info@bba-badsaarow.de',
    registerCourt: 'Amtsgericht Frankfurt (Oder)',
    registerNumber: 'HRB 17338',
    vatId: 'DE188194413',
    serviceArea: "Deutschland, Österreich und Schweiz",
    tagline: "Beton digital, verantwortungsvoll begleitet."
}
